import React from 'react';
import { Box } from '@mui/material';

// Адаптивная ширина сайдбара
const drawerWidth = {
  sm: 300, // Планшеты
  md: 320, // Десктоп
  lg: 340, // Большие экраны
};

interface MainContentProps {
  children: React.ReactNode;
  fullWidth?: boolean;
}

const MainContent: React.FC<MainContentProps> = ({ children, fullWidth = false }) => {
  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        width: fullWidth
          ? '100%'
          : {
              xs: '100%', // Явная ширина для работы overflow на мобильных
              sm: `calc(100% - ${drawerWidth.sm}px - 40px)`,
              md: `calc(100% - ${drawerWidth.md}px - 40px)`,
              lg: `calc(100% - ${drawerWidth.lg}px - 40px)`
            },
        ml: fullWidth ? 0 : { sm: '40px' },
        position: 'relative',
        background: 'transparent',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box sx={{
        height: {
          xs: '80px', // Для мобильных (48px лого + 16px + 16px)
          sm: '112px' // Для десктопа (64px лого + 24px + 24px)
        }
      }} />
      <Box sx={{ position: 'relative', zIndex: 1, flexGrow: 1, p: 3, pb: 0 }}>
        {children}
      </Box>
    </Box>
  );
};

export default MainContent;